// A real emoji is one or more "atoms" — a pictographic char (optionally with
// a skin-tone modifier or variation selector), a flag (two regional
// indicators), or a keycap (digit/#/* + optional VS16 + combining enclosing
// keycap) — optionally joined by ZWJ into a longer sequence like a family or
// profession/gender combo. This isn't a perfect validator (the Unicode
// emoji spec grows every year), but it rejects plain text while accepting
// the sequences a real emoji keyboard produces.
const PICTOGRAPH = "\\p{Extended_Pictographic}(?:\\p{Emoji_Modifier}|\\uFE0F)?";
const FLAG = "\\p{Regional_Indicator}\\p{Regional_Indicator}";
const KEYCAP = "[0-9#*]\\uFE0F?\\u20E3";
const ATOM = `(?:${PICTOGRAPH}|${FLAG}|${KEYCAP})`;

const EMOJI_ONLY = new RegExp(`^${ATOM}(?:\\u200D${ATOM})*$`, "u");

export const isEmojiOnly = (value: string) => EMOJI_ONLY.test(value.trim());

export const EMOJI_ONLY_ERROR = "Det skal være en emoji – brug emoji-tastaturet, ikke almindelig tekst";
